'use strict';

/**
 * Number of milliseconds since epoch.
 *
 * @export
 */
export type Timestamp = number;
